import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import { useSelector } from "react-redux";

export const AppViews = () => {
  const user = useSelector((state) => state.User.user);
  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Switch>
        {user?.role == "admin" && (
          <>
            <Route
              path={`${APP_PREFIX_PATH}/fields`}
              component={lazy(() => import(`./fields`))}
            />
            <Route
              path={`${APP_PREFIX_PATH}/categories`}
              component={lazy(() => import(`./categories`))}
            />
            <Route
              path={`${APP_PREFIX_PATH}/navbar`}
              component={lazy(() => import(`./navbar`))}
            />
            <Route
              path={`${APP_PREFIX_PATH}/options`}
              component={lazy(() => import(`./options`))}
            />
            <Route
              path={`${APP_PREFIX_PATH}/pages`}
              component={lazy(() => import(`./pages`))}
            />
            <Route
              path={`${APP_PREFIX_PATH}/gallery`}
              component={lazy(() => import(`./upload`))}
            />
            <Route
              path={`${APP_PREFIX_PATH}/notifications`}
              component={lazy(() => import(`./notification`))}
            />

            <Route
              path={`${APP_PREFIX_PATH}/setting`}
              component={lazy(() => import(`./setting`))}
            />

            <Route
              path={`${APP_PREFIX_PATH}/category`}
              component={lazy(() => import(`./category`))}
            />

            <Route
              path={`${APP_PREFIX_PATH}/user`}
              component={lazy(() => import(`./user`))}
            />

            <Route
              path={`${APP_PREFIX_PATH}/videogallery`}
              component={lazy(() => import(`./videogallery`))}
            />

            <Route
              path={`${APP_PREFIX_PATH}/advertising`}
              component={lazy(() => import(`./advertising`))}
            />

            <Route
              path={`${APP_PREFIX_PATH}/page`}
              component={lazy(() => import(`./page`))}
            />

            <Route
              path={`${APP_PREFIX_PATH}/comments`}
              component={lazy(() => import(`./comments`))}
            />
            <Route
              path={`${APP_PREFIX_PATH}/banned-words`}
              component={lazy(() => import(`./banned-words`))}
            />
            <Route
              path={`${APP_PREFIX_PATH}/home`}
              component={lazy(() => import(`./home`))}
            />
            <Route
              path={`${APP_PREFIX_PATH}/content`}
              component={lazy(() => import(`./content`))}
            />
            <Route
              path={`${APP_PREFIX_PATH}/report`}
              component={lazy(() => import(`./report`))}
            />
          </>
        )}

        <Route
          path={`${APP_PREFIX_PATH}/home`}
          component={lazy(() => import(`./home`))}
        />
        <Route
          path={`${APP_PREFIX_PATH}/content`}
          component={lazy(() => import(`./content`))}
        />

        <Redirect from={`${APP_PREFIX_PATH}`} to={`${APP_PREFIX_PATH}/home`} />
      </Switch>
    </Suspense>
  );
};

export default React.memo(AppViews);
